class RosviaHero extends HTMLElement {
  connectedCallback() {
    this.slides = [...this.querySelectorAll('[data-hero-slide]')];
    this.dots = [...this.querySelectorAll('[data-hero-dot]')];
    this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (this.slides.length < 2) return;
    this.querySelector('[data-hero-next]')?.addEventListener('click', () => this.navigate(this.index + 1));
    this.querySelector('[data-hero-previous]')?.addEventListener('click', () => this.navigate(this.index - 1));
    this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.navigate(index)));
    this.addEventListener('keydown', (event) => {
      if (event.target.closest('input, textarea, select')) return;
      if (event.key === 'ArrowRight') this.navigate(this.index + 1);
      if (event.key === 'ArrowLeft') this.navigate(this.index - 1);
    });
    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => this.start());
    this.addEventListener('focusin', () => this.stop());
    this.addEventListener('focusout', () => this.start());
    this.bindSwipe();
    this.start();
  }
  bindSwipe() {
    // Touch swipe and mouse drag. Horizontal movement past the threshold changes slide;
    // vertical scrolling on phones is left to the browser.
    const viewport = this.querySelector('.hero-carousel__viewport') || this;
    viewport.style.touchAction = 'pan-y';
    let startX = 0; let startY = 0; let tracking = false; let moved = false;
    viewport.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      if (event.target.closest('a, button, input, select, textarea')) return;
      tracking = true; moved = false; startX = event.clientX; startY = event.clientY;
    });
    viewport.addEventListener('pointermove', (event) => {
      if (!tracking) return;
      if (Math.abs(event.clientX - startX) > 10 && Math.abs(event.clientX - startX) > Math.abs(event.clientY - startY)) moved = true;
    });
    const finish = (event) => {
      if (!tracking) return;
      tracking = false;
      const deltaX = event.clientX - startX;
      if (moved && Math.abs(deltaX) > 50) this.navigate(this.index + (deltaX < 0 ? 1 : -1));
    };
    viewport.addEventListener('pointerup', finish);
    viewport.addEventListener('pointercancel', () => { tracking = false; });
    viewport.addEventListener('click', (event) => { if (moved) { event.preventDefault(); event.stopPropagation(); moved = false; } }, true);
    viewport.addEventListener('dragstart', (event) => event.preventDefault());
  }
  navigate(index) {
    this.go(index);
    this.start();
  }
  go(index) {
    this.index = (index + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, slideIndex) => {
      const active = slideIndex === this.index;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', String(!active));
      slide.toggleAttribute('inert', !active);
    });
    this.dots.forEach((dot, dotIndex) => {
      const active = dotIndex === this.index;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-selected', String(active));
    });
  }
  start() {
    this.stop();
    if (this.dataset.autoplay !== 'true' || this.reducedMotion || this.slides.length < 2) return;
    if (this.matches(':hover') || this.contains(document.activeElement)) return;
    this.timer = window.setInterval(() => this.go(this.index + 1), Number(this.dataset.delay) || 6000);
  }
  stop() { if (this.timer) window.clearInterval(this.timer); this.timer = null; }
}
if (!customElements.get('rosvia-hero')) customElements.define('rosvia-hero', RosviaHero);
